module.exports = __webpack_public_path__ + "static/media/system_flow_id_check.01d1f955.svg";